/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Peoples Best",
  description:
    "Personal portfolio at a cool rate. Only GHS 400/year or GHS 40/month!",
  og: {
    title: "Peoples Best",
    type: "website",
    url: "www.peoplesbest.net",
  },
};

//Home Page
const greeting = {
  title: "Personal Portfolio",
  logo_name: "Peoples Best",
  nickname: "Personal Portfolio",
  subTitle: "at a cool rate. Only GHS 400/year or GHS 40/month!",
  resumeLink: "https://www.linkedin.com/in/earkohaddo/",
  portfolio_repository:
    "https://docs.google.com/forms/d/e/1FAIpQLSeTa0DeUDq_FxcVeREeNM-oJeAB995ZJLMw46_EDtpLclTplQ/viewform?usp=header",
  githubProfile: "https://github.com/arkohaddoebenezer",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/arkohaddoebenezer",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/earkohaddo/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:arkohaddoebenezer21@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "Facebook",
    link: "https://web.facebook.com/arkohaddo",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/earkohaddo/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "What you will get!",
      fileName: "FullStackImg",
      skills: [
        "⚡ Beautiful, Custom-Designed Portfolio — Tailored to your style and profession.",
        "⚡ Mobile-Friendly Design — Looks stunning on phones, tablets, and computers.",
        "⚡ Custom Sub Domain Name — Example: www.yourname.peoplesbest.net to make you look legit and professional",
        "⚡ Fast Loading Speed — Optimized for performance so visitors never have to wait.",
        "⚡ Easy Updates — You can update your projects, skills, and bio anytime.",
        "⚡ SEO-Ready — Set up to help you rank on Google and get discovered.",
        "⚡ One-on-One Support — Personal help if you need updates, advice, or tweaks.",
      ],
      softwareSkills: [],
    },
  ],
};


export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
};
